export interface QrCodePreference {
    enabled: boolean;
    ticketGenerationStrategy: TicketGenerationStrategy;
    ticketSyntax: string;
}

export enum TicketGenerationStrategy {
    BOOKING = "booking",
    GUEST = "guest",
}

export enum TicketSyntax {
    TICKET_CODE = "ticketCode",
}
